import { ArrowDownRight, MapPin } from "lucide-react";

const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/04d02fc6-d01d-49d7-84e6-1c31d05566a1/images/83007d90aaba6497060c986d48796d6b07621ae7d5b6a65223e2a5c7ee5d74df.png";

export const Hero = () => {
  const scrollToWaitlist = () => {
    const el = document.getElementById("waitlist");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#1e2528]"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Motorcycle on a mountain road at golden hour"
          className="w-full h-full object-cover object-center scale-105"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1e2528] via-[#1e2528]/70 to-[#1e2528]/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1e2528]/85 via-[#1e2528]/40 to-transparent" />
        <div className="grain" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-32 md:pt-40 pb-20 md:pb-28 flex flex-col min-h-screen">
        {/* Top meta line */}
        <div className="reveal flex items-center gap-3 text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#ccd3d6]">
          <span className="inline-block w-8 h-px bg-[#e89b1f]" />
          <MapPin className="w-3.5 h-3.5 text-[#e89b1f]" />
          <span>Made for India · Coming Soon</span>
        </div>

        {/* Hero headline */}
        <h1
          data-testid="hero-headline"
          className="reveal delay-100 mt-8 md:mt-10 font-display uppercase text-[#f7f7f7] leading-[0.85] tracking-tight text-6xl sm:text-7xl md:text-8xl lg:text-[9.5rem]"
        >
          Bikes.
          <br />
          Roads.
          <br />
          <span className="text-[#e89b1f]">Freedom.</span>
        </h1>

        {/* Sub copy */}
        <div className="reveal delay-200 mt-8 md:mt-10 grid md:grid-cols-12 gap-6 md:gap-10 items-end">
          <p className="md:col-span-6 lg:col-span-5 text-base md:text-lg text-[#e6ebed]/80 max-w-xl font-light leading-relaxed">
            Tripzo Rentals is a new way to ride India. From the daily Honda
            Activa to flagship 1000cc superbikes — a curated fleet for every
            kind of rider, ready at trailheads across the country.
          </p>

          <div className="md:col-span-6 lg:col-span-7 flex md:justify-end">
            <button
              data-testid="hero-cta-scroll-waitlist"
              onClick={scrollToWaitlist}
              className="group inline-flex items-center gap-3 bg-[#e89b1f] hover:bg-[#ffc543] text-[#1e2528] px-7 py-4 rounded-sm font-medium text-sm tracking-[0.15em] uppercase transition-colors"
            >
              Join the Waitlist
              <ArrowDownRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
            </button>
          </div>
        </div>

        {/* Coming Soon mark */}
        <div
          data-testid="coming-soon-mark"
          className="reveal delay-300 mt-20 md:mt-28 flex items-center gap-6"
        >
          <span className="inline-block w-12 md:w-20 h-px bg-[#e89b1f]" />
          <span className="font-display text-5xl sm:text-6xl md:text-8xl tracking-tight uppercase text-[#e89b1f] leading-none">
            Coming Soon
          </span>
        </div>

        <div className="flex-1" />
      </div>
    </section>
  );
};
